import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import MailLockIcon from '@mui/icons-material/MailLock';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';


const Root_Footer = () => {
    return (
      <footer class="footer-section">
      <div class="container">
          <div class="footer-wrap pt-5 pb-5">
              <div class="flex-center justify-content-between ">
                  <div class=" ">
                      <div class="single-wrap">
                          <LocationOnIcon/>
                          <div class="wrap-text">
                              <h4 className='footer-sec-title'>Find us</h4>
                              <p className='lh-lg'>7-11 Barking Rd, East Ham, <br/>
                              London, UK, Zip: nE61PWt
                              </p>
                          </div>
                      </div>
                  </div>
                  <div class=" ">
                      <div class="single-wrap">
                          <CallIcon/>
                          <div class="wrap-text">
                              <h4 className='footer-sec-title'>Call us</h4>
                              <span>+91 9995473245</span>
                          </div>
                      </div>
                  </div>
                  <div class=" ">
                      <div class="single-wrap">
                          <MailLockIcon/>
                          <div class="wrap-text">
                              <h4 className='footer-sec-title'>Mail us</h4>
                              <span>info@ayatacommerce.com</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="footer-content pt-5 pb-5">
              <div class="row ">
                  <div class="col-lg-4">
                      <div class="footer-widget">
                          <div >
                                <a className='logo logo-dark' href='/'></a>
                          </div>
                          <div class="lh-base">
                              E-commerce website specializing in a wide array of fashion items for both men and women. Explore our extensive collection of clothing, accessories, and footwear, curated to reflect the latest trends and styles.
                          </div>
                          <div class="footer-social-icon mt-3">
                              <h4 className='footer-sec-title'>Follow us</h4>
                              <a href="#"><FacebookIcon/></a>
                              <a href="#"><InstagramIcon/></a>                              
                              <a href="#"><LinkedInIcon/></a>
                              <a href="#"><WhatsAppIcon/></a>
                              

                          </div>
                      </div>
                  </div>
                  <div class="col-lg-8"> 
                  <div className='row justify-content-end '>
                        <div className='footer-widget col-md-6 col-lg-4 col-xl-3'>
                                <h3>Company</h3>
                                <ul>
                                    <li><a href="#">About Us</a></li>
                                    <li><a href="#">Contact Us</a></li>
                                    <li><a href="#">Expert Team</a></li>
                                    <li><a href="#">Latest News</a></li>
                                    <li><a href="#">FAQs</a></li>
                                    <li><a href="#">Terms and Conditions</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                        </div>
                        <div className='footer-widget col-md-6 col-lg-4 col-xl-3'>
                                <h3>MEN</h3>
                                <ul>
                                    <li><a href="/men/clothing">Clothing</a></li>
                                    <li><a href="/men/shoes">Shoes</a></li>
                                    <li><a href="/men/accessories">Accessories</a></li>
                                    <li><a href="/men/bags">Bags</a></li>
                                    <li><a href="/men/watches">Watches</a></li>
                                    <li><a href="/men/fragrances">Fragrances</a></li>
                                    <li><a href="/men/grooming">Grooming</a></li>
                                    <li><a href="/men/sportswear">Sportswear</a></li>
                                    <li><a href="/men/underwear">Underwear</a></li>
                                    <li><a href="/men/tech-gadgets">Tech Gadgets</a></li>
                                </ul>
                        </div>
                        <div className='footer-widget col-md-6 col-lg-4 col-xl-3'>
                                <h3>WOMEN</h3>
                                <ul>
                                    <li><a href="/women/clothing">Dresses</a></li>
                                    <li><a href="/women/tops">Tops</a></li>
                                    <li><a href="/women/bottoms">Bottoms</a></li>
                                    <li><a href="/women/shoes">Shoes</a></li>
                                    <li><a href="/women/handbags">Handbags</a></li>
                                    <li><a href="/women/jewelry">Jewelry</a></li>
                                    <li><a href="/women/beauty-products">Beauty Products</a></li>
                                    <li><a href="/women/lingerie">Lingerie</a></li>
                                    <li><a href="/women/activewear">Activewear</a></li>
                                    <li><a href="/women/sunglasses">Sunglasses</a></li>
                                </ul>
                        </div>                        
                  </div>
                          
                      
                  </div>

              </div>
          </div>
      </div>
      <div class="copyright-area text-center small">
      © {new Date().getFullYear()}, All rights reserved by <a href="https://www.ayatacommerce.com" target="_blank" rel="noopener noreferrer">www.ayatacommerce.com</a>
      </div>
  </footer>
      );
};

export default Root_Footer;